<section class="banner-area banner-area-two bg-2">
    <div class="container">
        <div class="banner-content">
            <span class="top-title">World Class Cyber Security</span>
            <h1>Powerful Protection Easy Recovery</h1>
            <p>Cybersecurity is the protection  from the theft to protect of our computer systems and networks or being damaged of our hardware and software.</p>
            <a routerLink="/about" class="default-btn"><span>About Us</span></a>
        </div>
    </div>
</section>